import { useState } from "react";
import { motion } from "framer-motion";
import { Building2, UserRound } from "lucide-react";
import { STEPS_CANDIDATE, STEPS_EMPLOYER } from "../../content/site";

const TABS = [
  { id: "employer", label: "Für Arbeitgeber", icon: Building2, steps: STEPS_EMPLOYER },
  { id: "candidate", label: "Für Bewerber", icon: UserRound, steps: STEPS_CANDIDATE },
];

export const ProcessTabs = ({ initial = "employer" }) => {
  const [tab, setTab] = useState(initial);
  const active = TABS.find((t) => t.id === tab);
  return (
    <div data-testid="process-tabs">
      <div role="tablist" aria-label="Ablauf auswählen" className="inline-flex rounded-full border border-slate-200 bg-white p-1.5">
        {TABS.map((t) => (
          <button
            key={t.id} role="tab" aria-selected={tab === t.id} aria-controls={`panel-${t.id}`} id={`tab-${t.id}`}
            onClick={() => setTab(t.id)} data-testid={`process-tab-${t.id}`}
            className={`relative inline-flex items-center gap-2 rounded-full px-4 sm:px-6 py-2.5 text-sm font-semibold transition-colors ${tab === t.id ? "text-white" : "text-slate-700 hover:text-[color:var(--navy)]"}`}
          >
            {tab === t.id && <motion.span layoutId="tab-pill" className="absolute inset-0 rounded-full bg-[color:var(--navy)]" transition={{ type: "spring", stiffness: 380, damping: 32 }} />}
            <t.icon size={16} className="relative" /><span className="relative">{t.label}</span>
          </button>
        ))}
      </div>
      <ol id={`panel-${tab}`} role="tabpanel" aria-labelledby={`tab-${tab}`} className="mt-10 grid gap-px overflow-hidden rounded-3xl border border-slate-200 bg-slate-200 sm:grid-cols-2 lg:grid-cols-4">
        {active.steps.map((s, i) => (
          <motion.li
            key={`${tab}-${i}`}
            initial={{ opacity: 0, y: 14 }} animate={{ opacity: 1, y: 0 }} transition={{ delay: i * 0.05, duration: 0.45 }}
            className={`group relative bg-white p-7 md:p-8 min-h-[210px] transition-colors hover:bg-[color:var(--mist)] ${i === active.steps.length - 1 ? "sm:col-span-2 lg:col-span-1 bg-[color:var(--mist)]" : ""}`}
            data-testid={`process-step-${tab}-${i + 1}`}
          >
            <span className="font-serif-accent text-5xl text-[color:var(--teal)]">{String(i + 1).padStart(2, "0")}</span>
            <h3 className="mt-5 text-lg font-bold text-[color:var(--navy)]">{s.t}</h3>
            <p className="mt-2 text-sm leading-relaxed text-slate-600">{s.d}</p>
          </motion.li>
        ))}
        <li className="hidden lg:flex bg-[color:var(--navy)] p-8 text-white items-end">
          <p className="text-sm leading-relaxed text-slate-200">Der konkrete Ablauf kann je nach Beruf, Herkunftsland und Einzelfall abweichen.</p>
        </li>
      </ol>
      <p className="mt-5 text-sm text-slate-600 lg:hidden">Der konkrete Ablauf kann je nach Beruf, Herkunftsland und Einzelfall abweichen.</p>
    </div>
  );
};
